import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { belongsTo, attr } from '@ember-data/model';

var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3;
let InvoicemailsendModel = (_dec = belongsTo('invoice', {
  inverse: 'invoicemailsends',
  async: false
}), _dec2 = attr('string'), _dec3 = attr('boolean', {
  defaultValue: false
}), _class = class InvoicemailsendModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "invoice", _descriptor, this);
    _initializerDefineProperty(this, "mandrill_id", _descriptor2, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor3, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "invoice", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "mandrill_id", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { InvoicemailsendModel as default };
//# sourceMappingURL=invoicemailsend.js.map
